import React from 'react'
import { Container } from 'react-bootstrap'
import { Link, useParams } from 'react-router'

import { useAuth } from '../../../../hooks/useAuth'
import { useIsRoute } from '../../../../hooks/useIsRoute'
import { REFERRALS_TAB } from '../../../../lib/constants'
import { ROUTES } from '../../../../lib/routes'
import routeService from '../../../../lib/services/routeService'
import { REFERRAL_INVITE_PARAMS } from '../../../../pages/referralInvite/constants'
import InvalidOrExpiredCard from '../../../misc/InvalidOrExpiredCard'

const ReferralInviteClaimedError: React.FC = () => {
  const { isAuthenticated } = useAuth()
  const params = useParams()
  const referralId = params[REFERRAL_INVITE_PARAMS.referralId]
  const isRoute = useIsRoute()
  const isReferralInviteDetailPage =
    isRoute(ROUTES.referralInvite) && !!referralId

  const loginRoute = isReferralInviteDetailPage
    ? routeService.referralSummary(+referralId)
    : routeService.referrals({ tab: REFERRALS_TAB.received })

  const referralTerm = isReferralInviteDetailPage ? 'referral' : 'referrals'

  return (
    <div className="mx-auto mt-6 pb-5" style={{ maxWidth: '700px' }}>
      <Container>
        <InvalidOrExpiredCard
          title="Link is no longer valid"
          className="mw-md"
          content={
            <>
              <p className="mb-2">
                This invite link has already been claimed and is no longer
                valid.
              </p>

              {isAuthenticated ? (
                <>
                  <p>
                    If you previously claimed the invite, please try viewing the{' '}
                    {referralTerm} on RQ.
                  </p>

                  <Link to={loginRoute} className="btn btn-primary btn-lg">
                    View {referralTerm} on RQ
                  </Link>
                </>
              ) : (
                <>
                  <p>
                    If you previously claimed the invite, please login to view
                    your {referralTerm}.
                  </p>

                  <Link to={loginRoute} className="btn btn-primary btn-lg">
                    Login to RQ
                  </Link>
                </>
              )}
            </>
          }
        />
      </Container>
    </div>
  )
}

export default ReferralInviteClaimedError
